import * as React from "react";

import { Modal } from "src/library/components/Modal";
import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { formatDate } from "src/library/utils/moment";

import {
  IOrder,
  OrderOrigin
} from "../../api/orders.api";

interface IProps {
  show: boolean;
  order: IOrder;
  onConfirm: () => void;
  handleDismiss: () => void;
  terminology: ITerminology;
  loading: boolean;
  success: IOrder | null;
  failure: string | undefined;
}

const CancelOrderModal: React.ReactFCWithChildren<IProps> = ({
  show, onConfirm, handleDismiss, terminology, order, loading, success, failure
}) => {
  // dynamic message to display
  const message = React.useMemo(() => {
    if (!loading && !success) {
      if (order.origin === OrderOrigin.File && order.type === "bulk") {
        return `Are you sure you want to cancel this ${terminology.order.singular.text}? This ${terminology.order.singular.text} gets automatic updates and cancelling it will prevent any further updates to this ${terminology.order.singular.text}. This action cannot be undone.`;
      }

      return `Are you sure you want to remove the ${terminology.order.singular.text} with delivery on ${formatDate(
        order.orderDeliveryDate
      )}. This action cannot be undone.`;
    } else if (!success) {
      return "Cancelling order...";
    } else if (failure) {
      return failure;
    } else {
      return `Your ${terminology.order.singular.text} has been cancelled!`;
    }
  }, [
    loading,
    success,
    failure,
    order.origin,
    order.type,
    order.orderDeliveryDate,
    terminology.order.singular.text
  ]);

  return (
    <Modal
      small
      type="confirm"
      show={show}
      title={`Cancel ${terminology.order.singular.text}`}
      body={message}
      loading={loading}
      actions={!success ? [
        {
          name: "Don't Cancel",
          action: () => handleDismiss(),
          $buttonType: "secondary"
        },
        {
          name: `Cancel ${terminology.order.singular.text}`,
          action: () => {
            onConfirm();
          },
          $buttonType: "primary"
        }
      ] : [
        {
          name: "Done",
          action: () => handleDismiss(),
          $buttonType: "secondary"
        }
      ]}
      backgroundAction={() => handleDismiss()}
    />
  );
};

export default CancelOrderModal;
